/// <reference lib="dom" />
import { AppProviders } from '@app/providers/app-providers'
import { KeyedContactChannelsProvider } from '@app/providers/keyed-contact-channels-provider'
import type { HelpCenterUrls } from '@shared/types/url.types'
import { useSwanStyleKeys, useUserContext } from '@vp/ubik-context'
import { ContactPageContent } from './page-content'
import { Helmet } from 'react-helmet'
import { getPageTitle } from '@shared/config'

export type ContactChannel = 'callback' | 'email'

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  localizationData: Record<string, any>
  helpCenterUrls?: HelpCenterUrls | null
  channel?: ContactChannel
  /** The phone channel's SSR-fetched, pre-formatted business-hours rows. */
  phoneShortSchedule?: string[]
  concordApiServiceUrl: string
  bopApiServiceUrl: string
  concordTenantId: string
}

export const ContactPageFragment = (props: Props) => {
  const { locale } = useUserContext()
  useSwanStyleKeys(['core', 'button', 'icon', 'grid', 'utility', 'progressBar', 'listbox', 'fileDropzone', 'fileTile', 'spinner', 'alertBox', 'selectionSet'])

  return (
    <>
      <Helmet defer>
        <title>{getPageTitle(locale)}</title>
      </Helmet>
      <AppProviders
        localizationData={props.localizationData}
        helpCenterUrls={props.helpCenterUrls}
        phoneShortSchedule={props.phoneShortSchedule}
        channel={props.channel}
        concordApiServiceUrl={props.concordApiServiceUrl}
        bopApiServiceUrl={props.bopApiServiceUrl}
        concordTenantId={props.concordTenantId}
      >
        <KeyedContactChannelsProvider origin="Help-Center-Contact-Us-Page" useRecaptcha loadingFallback={null}>
          <ContactPageContent {...props} />
        </KeyedContactChannelsProvider>
      </AppProviders>
    </>
  )
}
